import { LoggerInstance } from 'global-logger-services-js/global-logger-services-js-bundle';
import { SingletonSharedData } from '../singletonSharedData'

LoggerInstance.setApplication("[Galatea-UI]");

export class Logger {
	static getUserID() {
		var sharedData = new SingletonSharedData();
		var user = sharedData.getParameters();
		var userId = user ? user.UserID : 0;
		LoggerInstance.setUserId(userId);
		return userId;
	}

	setUserType(userType) {
		Logger.setUserType(userType);
	}

	static setUserId(userId) {
		LoggerInstance.setUserId(userId);
	}

	static Trace(...msg) {
		LoggerInstance.Trace([`[Galatea-UI]`, ...msg]);
	}

	static Debug(...msg) {

		LoggerInstance.Debug([`[Galatea-UI]`, ...msg]);
	}

	static Warning(...msg) {
		LoggerInstance.Warning([`[Galatea-UI]`, ...msg]);
	}

	static Warn(...msg) {
		LoggerInstance.Warning([`[Galatea-UI]`, ...msg]);
	}

	static Info(...msg) {
		LoggerInstance.Info([`[Galatea-UI]`, ...msg]);
	}

	static Error(...msg) {
		LoggerInstance.Error(`[Galatea-UI]lib[UserID:${Logger.getUserID()}]`, ...msg);
	}

	static JsError(...msg) {
		LoggerInstance.JsError(`[Galatea-UI]lib[UserID:${Logger.getUserID()}]`, ...msg);
	}

	static JsWarning(...msg) {
		LoggerInstance.JsWarning([`[Galatea-UI]`, ...msg]);
	}

	static EnableLocalLog(enabled, time) {
		LoggerInstance.setLocalLogger(enabled);
		enabled && LoggerInstance.setLocalStorageTime(time);
	}
}


// WEBPACK FOOTER //
// ./src/js/helpers/Logger.js